export default __webpack_public_path__ + "static/media/NGORealCase1-moblie-en.b386f98d.jpg";